import * as React from 'react';
import { RouteObject } from 'react-router-dom';

// Sub-routes
import { ClientContactsRoutes } from './children/Contacts';
import { ClientExportsRoutes } from './children/Exports';
import { ClientFinancialsRoutes } from './children/Financials';
import { ClientGoalsRoutes } from './children/Goals';
import { ClientSettingsRoutes } from './children/Settings';
import { ClientSurveysRoutes } from './children/Surveys';
import { ClientReportsRoutes } from './children/Reports';
import { ClientProfileRoutes } from './children/Profile';
import { ClientOnboardingRoutes } from './children/Onboarding';

const ClientRouteWrapper = React.lazy(
    () => import(/* webpackChunkName: "client-route-wrapper" */ '../../components/ClientRouteWrapper')
);
const ClientDashboard = React.lazy(
    () => import(/* webpackChunkName: "client-dashboard" */ '../../containers/Client/Dashboard')
);

export const ClientRoutes: RouteObject[] = [
    {
        element: <ClientRouteWrapper />,
        children: [
            {
                index: true,
                element: (
                    <React.Suspense fallback={<>...</>}>
                        <ClientDashboard />
                    </React.Suspense>
                )
            },
            ClientContactsRoutes,
            ClientExportsRoutes,
            ClientFinancialsRoutes,
            ClientGoalsRoutes,
            ClientSettingsRoutes,
            ClientSurveysRoutes,
            ClientReportsRoutes,
            ClientProfileRoutes,
            ClientOnboardingRoutes
        ]
    }
];
